import { JSX } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../common/components/Button";

export const TermsAndConditionsPageContainer = (): JSX.Element => {
    const navigate = useNavigate();

    const handleGoBack = (): void => {
        navigate(-1);
    };

    return (
        <div className="p-terms-and-conditions">
            <div className="p-terms-and-conditions__back-button">
                <Button type="button" variant="tertiary" onClick={handleGoBack}>
                    ← Back
                </Button>
            </div>
            <div className="p-terms-and-conditions__content-wrapper">
                <div className="p-terms-and-conditions__content">
                    <h1>Terms & Conditions – SPRSO Raffle</h1>

                    <section>
                        <h2>1. Organizer</h2>
                        <p>
                            This raffle is organized by{" "}
                            <b>Bravilor Bonamat B.V.</b>, located at
                            Pascalstraat 20, 1704 RD Heerhugowaard.
                        </p>
                    </section>

                    <section>
                        <h2>2. Participation</h2>
                        <ul>
                            <li>
                                Everyone visiting the trade show can vote for
                                their favorite color of the new Sprso.
                            </li>
                            <li>
                                Participation in the raffle to win a Sprso is
                                open to all individuals aged 18 and above.
                            </li>
                            <li>
                                Employees of Bravilor Bonamat and their
                                immediate family members are excluded from
                                participation.
                            </li>
                            <li>Each person may enter the raffle only once.</li>
                        </ul>
                    </section>

                    <section>
                        <h2>3. Entry in the Raffle</h2>
                        <ul>
                            <li>
                                To enter the raffle, participants must provide
                                their contact details (such as name, email
                                address, and/or phone number).
                            </li>
                            <li>
                                Providing contact details is voluntary, but
                                necessary to participate in the raffle.
                            </li>
                        </ul>
                    </section>

                    <section>
                        <h2>4. Use of Personal Data</h2>
                        <ul>
                            <li>
                                The personal details provided will only be used
                                for:
                                <ul>
                                    <li>administering the raffle,</li>
                                    <li>randomly selecting a winner,</li>
                                    <li>contacting the winner.</li>
                                </ul>
                            </li>
                            <li>
                                After the raffle has ended and the winner has
                                been successfully contacted, all personal data
                                will be permanently deleted.
                            </li>
                            <li>
                                Personal data will not be used for marketing
                                purposes or shared with third parties.
                            </li>
                            <li>
                                Bravilor Bonamat will handle all personal data
                                in accordance with the General Data Protection
                                Regulation (GDPR).
                            </li>
                        </ul>
                    </section>

                    <section>
                        <h2>5. Prize</h2>
                        <ul>
                            <li>
                                The prize consists of <b>one SPRSO machine.</b>
                            </li>
                            <li>
                                The prize is non-transferable and cannot be
                                exchanged for cash or other products.
                            </li>
                            <li>
                                Bravilor Bonamat reserves the right to
                                substitute the prize with a similar item of
                                equal value if circumstances make this
                                necessary.
                            </li>
                        </ul>
                    </section>

                    <section>
                        <h2>6. Winner Selection and Notification</h2>
                        <ul>
                            <li>
                                The winner will be selected at random from all
                                valid entries.
                            </li>
                            <li>
                                The draw will take place within 7 days after the
                                trade show has ended.
                            </li>
                            <li>
                                The winner will be contacted using the contact
                                details provided.
                            </li>
                            <li>
                                If the winner cannot be reached within 5 days, a
                                new winner will be drawn.
                            </li>
                        </ul>
                    </section>

                    <section>
                        <h2>7. Liability</h2>
                        <ul>
                            <li>
                                Bravilor Bonamat is not responsible for any
                                technical issues, lost entries, or incorrect
                                information provided by participants.
                            </li>
                            <li>
                                Participation in the raffle is at the entrant's
                                own risk.
                            </li>
                        </ul>
                    </section>

                    <section>
                        <h2>8. Acceptance of Terms</h2>
                        <p>
                            By entering the raffle, participants confirm that
                            they agree to these Terms and Conditions.
                        </p>
                    </section>

                    <section>
                        <h2>9. Governing Law</h2>
                        <p>
                            These Terms and Conditions are governed by the laws
                            of the Netherlands.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};
